import {
  applicationJson,
  multiparFormData,
  roles,
  StorageKeys,
} from "../constants";
import {
  AdminRoutesForServerCalls,
  getPathDescription,
} from "../modules/AdminPortal/AdminServerCallRoutes";
import axiosInstance from "./axios-instance";
import { getLocalStorageItem } from "./localStorage";

const buildURL = (url, isAudit) => {
  let BaseUrl;
  if(isAudit) {
    BaseUrl = process.env.REACT_APP_BASE_AUDIT_API_URL
  } else {
    BaseUrl = process.env.REACT_APP_BASE_API_URL
  }
  return BaseUrl + url;
};

const buildHeaders = (auth, contentType = applicationJson) => {
  const isAdmin =
    getLocalStorageItem(StorageKeys?.activeRole) === roles?.SuperAdmin ||
    getLocalStorageItem(StorageKeys?.activeRole) === roles?.Admin;

  let headers = {
    "Content-Type": contentType,
  };

  if (isAdmin) {
    const moduleName = AdminRoutesForServerCalls?.find(
      (x) => x === window.location.pathname
    );
    if (moduleName) {
      headers = { ...headers, "Module-Name": getPathDescription(moduleName) };
    }
  }

  if (auth === true) {
    headers = { ...headers };
  }
  return headers;
};

const getRequest = (url, auth = true, token = null) => {
  const completeUrl = buildURL(url);
  let headers = buildHeaders(auth);
  if (token) {
    headers = {
      ...headers,
      ...{
        "ssf-auth": `Bearer ${token}`,
      },
    };
  }
  const requestOptions = {
    headers: headers,
  };

  return axiosInstance.get(completeUrl, requestOptions);
};

const getRequestWithParams = (url, auth = true, params = null) => {
  const completeUrl = buildURL(url);
  const requestOptions = {
    headers: buildHeaders(auth),
    params: params,
  };
  return axiosInstance.get(completeUrl, requestOptions);
};

const deleteRequest = (url, auth = true) => {
  const completeUrl = buildURL(url);
  const requestOptions = {
    headers: buildHeaders(auth),
  };
  return axiosInstance.delete(completeUrl, requestOptions);
};

const postRequest = (
  url,
  dataObj = null,
  auth = true,
  token = null,
  isAudit = false
) => {
  const completeUrl = buildURL(url, isAudit);
  let headers = buildHeaders(auth);
  if (token) {
    headers = {
      ...headers,
      ...{
        "ssf-auth": `Bearer ${token}`,
      },
    };
  }
  return axiosInstance.post(completeUrl, dataObj, { headers: headers });
};

const postRequestWithFiles = (url, formData, auth = true) => {
  const completeUrl = buildURL(url);
  const requestOptions = {
    headers: buildHeaders(auth, multiparFormData),
  };
  return axiosInstance.post(completeUrl, formData, requestOptions);
};

const putRequest = (url, dataObj, auth = true) => {
  const completeUrl = buildURL(url);
  const requestOptions = {
    headers: buildHeaders(auth),
  };
  return axiosInstance.put(completeUrl, dataObj, requestOptions);
};

const putRequestWithFiles = (url, dataObj, auth = true) => {
  const completeUrl = buildURL(url);
  const requestOptions = {
    headers: buildHeaders(auth, multiparFormData),
  };
  return axiosInstance.put(completeUrl, dataObj, requestOptions);
};

export {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  postRequestWithFiles,
  putRequestWithFiles,
  getRequestWithParams,
};
